<template>
	<div class="title-page">
		<h1 class="title">Mes équipements</h1>
		<a class="button outline normal" @click="openUploadEquipment()">Ajouter un équipement</a>
	</div>
	<div class="card white large no-pdg">
		<div class="file-ctn">
			<h2>Détails de mes équipements</h2>
			<FileSizeProgress ref="fileSizeProgress" :propID="currentProperty.ID" />
		</div>
		<div v-if="equipments.length == 0" style="text-align: center; padding: 50px">
			<h2>Aucun équipement pour le moment</h2>
			<img src="https://www.mondomicil.fr/wp-content/uploads/2024/05/Fichier-9.png"
				alt="Aucun équipement trouvé" />
		</div>
		<div v-else-if="filteredCategories.length == 0" style="text-align: center; padding: 50px">
			<h2>Aucun équipement trouvé</h2>
			<img src="https://www.mondomicil.fr/wp-content/uploads/2024/05/Fichier-9.png"
				alt="Aucun équipement trouvé" />
		</div>
		<div v-else class="category" v-for="category in filteredCategories" :key="category.name">
			<h3 @click="toggleCategoryVisibility(category.name)">
				{{ category.name }}
				<i class="bi"
					:class="{ 'bi-caret-right-fill': !visibleCategories[category.name], 'bi-caret-down-fill': visibleCategories[category.name] }"></i>
			</h3>
			<div v-if="visibleCategories[category.name]" class="types">
				<div v-for="equipment in category.equipments" :key="equipment.ID" class="card white pdg-25">
					<div class="title-ctn">
						<h4>{{ equipment.name }}</h4>
						<div>
							<i class="file-icon bi bi-pencil-square" @click="openViewPopup(equipment)"></i>
							<i class="file-icon bi bi-trash-fill" @click="openPopup1(equipment.ID)"></i>
						</div>
					</div>
					<p class="file-info">Réf: {{ equipment.reference }}</p>
					<p class="file-info">Type: {{ equipment.typeName }}</p>
					<div v-for="file in equipment.files" :key="file.ID" class="file-entry">
						<i v-if="file.type === 'photos'" class="bi bi-file-image-fill"></i>
						<i v-else-if="file.type === 'notices'" class="bi bi-file-pdf-fill"></i>
						<p class="file-name">{{ file.name }}</p>
						<i class="file-icon bi bi-download" @click="downloadFile(file.ID)"></i>
						<i class="file-icon bi bi-eye-fill" @click="viewFile(file.ID)"></i>
						<i class="file-icon bi bi-trash-fill" @click="openPopup(file.ID)"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
	<ConfirmationPopup :isVisible="showPopup" title="Confirmer la suppression"
		message="Êtes-vous sûr de vouloir supprimer ce fichier ?" @confirm="deleteFile" @cancel="closePopup">
	</ConfirmationPopup>
	<ConfirmationPopup :isVisible="showPopup1" title="Confirmer la suppression"
		message="Êtes-vous sûr de vouloir supprimer cet équipement ?" @confirm="deleteEquipment" @cancel="closePopup1">
	</ConfirmationPopup>
	<EquipementSelectPopup :isVisible="showUploadEquipment" title="Ajouter un équipement" :propID="currentProperty.ID"
		@confirm="uploadEquipment" @cancel1="closeUploadEquipment">
	</EquipementSelectPopup>
	<EquipementViewPopup :isVisible="showViewPopup" title="Modifier un équipement" :equipment="this.showViewEquipment"
		@confirm="closeViewPopup" @cancel1="closeViewPopup"></EquipementViewPopup>
</template>

<script>
import EquipementSelectPopup from "@/components/EquipementSelectPopup.vue";
import EquipementViewPopup from "@/components/EquipementViewPopup.vue";
import ConfirmationPopup from "@/components/ConfirmationPopup";
import FileSizeProgress from "@/components/FileSizeProgress.vue";

export default {
	name: "MesEquipements",
	props: ["currentProperty", "user", "searchQuery"],
	components: {
		ConfirmationPopup,
		EquipementSelectPopup,
		EquipementViewPopup,
		FileSizeProgress,
	},
	data() {
		return {
			equipments: [],
			fileToDelete: "",
			showPopup: false,
			equipmentToDelete: "",
			showPopup1: false,
			showUploadEquipment: false,
			showViewPopup: false,
			showViewEquipment: {},
			visibleCategories: {},
		};
	},
	mounted() {
		if (this.currentProperty && Object.keys(this.currentProperty).length > 0) this.fetchEquipments();

		this.$watch("currentProperty", () => {
			if (this.currentProperty && Object.keys(this.currentProperty).length > 0) this.fetchEquipments();
		});
	},
	methods: {
		initializeVisibleCategories() {
			let isFirstCategory = true;
			this.sortedCategories.forEach((category) => {
				const categoryName = category.name;
				if (!this.visibleCategories[categoryName]) {
					if (isFirstCategory) {
						isFirstCategory = false;
						this.visibleCategories[categoryName] = true;
					} else {
						this.visibleCategories[categoryName] = false;
					}
				}
			});
		},
		toggleCategoryVisibility(categoryName) {
			this.visibleCategories[categoryName] = !this.visibleCategories[categoryName];
		},
		async fetchEquipments() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "equipements/p/" + this.currentProperty.ID, { method: "GET", credentials: "include", });
				const data = await response.json();

				if (data.error) return window.location.href = "/login";
				this.equipments = data;
				this.initializeVisibleCategories();
				this.resetFileSizeProgress();
			} catch (error) {
				console.error("Une erreur est survenue lors de la requête.");
			}
		},
		async deleteFile() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "equipements/fichier/delete/" + this.fileToDelete, { method: "GET", credentials: "include", });
				if (response.ok) {
					this.closePopup();
					this.fileToDelete = "";
					this.fetchEquipments();
				}
			} catch (error) {
				console.log("Une erreur est survenue lors de la requête.");
			}
		},
		async deleteEquipment() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "equipements/delete/" + this.equipmentToDelete, { method: "GET", credentials: "include", });
				if (response.ok) {
					this.closePopup1();
					this.equipmentToDelete = "";
					this.fetchEquipments();
				}
			} catch (error) {
				console.log("Une erreur est survenue lors de la requête.");
			}
		},
		openPopup(fileId) {
			this.fileToDelete = fileId;
			this.showPopup = true;
		},
		closePopup() {
			this.showPopup = false;
		},
		openPopup1(equipmentID) {
			this.equipmentToDelete = equipmentID;
			this.showPopup1 = true;
		},
		closePopup1() {
			this.equipmentToDelete = "";
			this.showPopup1 = false;
		},
		openUploadEquipment() {
			this.showUploadEquipment = true;
		},
		closeUploadEquipment() {
			this.showUploadEquipment = false;
		},
		uploadEquipment() {
			this.fetchEquipments();
			this.showUploadEquipment = false;
		},
		openViewPopup(equipment) {
			this.showViewEquipment = equipment;
			this.showViewPopup = true;
		},
		closeViewPopup() {
			this.fetchEquipments();
			this.showViewEquipment = {};
			this.showViewPopup = false;
		},
		resetFileSizeProgress() {
			this.$refs.fileSizeProgress.reset();
		},
		viewFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "read/" + fileId;
			window.open(url, "_blank");
		},
		downloadFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "download/" + fileId;
			window.open(url, "_blank");
		},
	},
	computed: {
		filteredEquipments() {
			const query = this.searchQuery.toLowerCase();
			return this.equipments.filter(equipment => equipment.name.toLowerCase().includes(query));
		},
		sortedCategories() {
			const categories = {};
			this.filteredEquipments.forEach((equipment) => {
				const typeName = equipment.typeName;
				if (!categories[typeName]) {
					categories[typeName] = [];
				}
				categories[typeName].push(equipment);
			});
			return Object.keys(categories)
				.sort()
				.map((name) => ({ name, equipments: categories[name], }));
		},
		filteredCategories() {
			return this.sortedCategories;
		},
	},
};
</script>
